import React, { useState, useEffect, useContext } from "react";
import "./Orders.css";
import { Button, Modal, Carousel, Popover } from "antd";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import { setTechOrderTab } from "../../../Redux/Actions/TechAppAction";
import { techappContext } from "../../../Api/techappReq";
import { useNavigate } from "react-router";
import Colors from "../../../Helper/Colors";
import completeTask from "../../../assets/images/techapp/completed-task.svg";
import failedTask from "../../../assets/images/techapp/error-task.svg";
import doingTask from "../../../assets/images/techapp/doing-task.svg";
import timeTask from "../../../assets/images/techapp/time-task.svg";
import availableTask from "../../../assets/images/techapp/available-task.svg";
import lockIcon from "../../../assets/images/lock.png";
import availableIcon from "../../../assets/images/not-available.png";
// import pages
import DoneOrders from "../../Pages/DoneOrders";
import FailedOrders from "../../Pages/FailedOrders";
import DoingOrders from "../../Pages/DoingOrders";
import SpecialOrders from "../../Pages/SpecialOrders";
import AvailableOrders from "../../Pages/AvailableOrders";
import NewMessage from "../new_message";
import lang from "../lang/lang.json";
import Layout from "../../../layout";
import { IoSearchSharp } from "react-icons/io5";

const Orders = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lockModal, setLockModal] = useState(false);
  const [unavailableModal, setUnavailableModal] = useState(false);
  const techOrderTab = useSelector(
    (state) => state.TechAppReducer.techOrderTab
  );
  const unreadMessages = useSelector(
    (state) => state.TechAppReducer.unreadMessages
  );
  const profileData = useSelector((state) => state.TechAppReducer.profileData);
  const showUnread = useSelector((state) => state.TechAppReducer.showUnread);
  const hints = useSelector((state) => state.TechAppReducer.hints);
  const { getSliderImages, sliderData } = useContext(techappContext);

  useEffect(() => {
    getSliderImages();
  }, []);

  return (
    <Layout>
      <div
        className="tech-app-orders"
        id={profileData?.available === 0 ? "orders_bg_of" : ""}
      >
        <div className="tech-app-header">
          <span
            id={profileData?.available === 0 ? "text_of" : ""}
            style={{ marginLeft: "auto" }}
          >
            {lang.ORDERS}
          </span>
          {/* help popover */}
          {hints.map((hint, index) => {
            if (
              hint.section === "orders_page" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: 8 }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              hint.section === "orders_page" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  style={{ marginRight: 8 }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            }

            return '';
          })}
          <IoSearchSharp
            onClick={() => {
              navigate("/techapp/search");
            }}
            style={{ marginRight: "25px" }}
          />
        </div>
        {/* new messages */}
        {!localStorage.getItem("auth_from_admin") &&
          showUnread &&
          unreadMessages.map((message) => (
            <NewMessage message={message} id={message.id} />
          ))}
        {/* order statuses */}
        <div className="tech-app-orders-status">
          {/* available status */}
          <div
            onClick={() => {
              dispatch(setTechOrderTab(4));
            }}
            className={
              techOrderTab === 4 ? "tech-app-orders-status-active" : ""
            }
            id="order_status_tabs_available"
          >
            <div>
              <img
                id={profileData?.available === 0 ? "image_of" : ""}
                src={availableTask}
                alt="complete orders"
              />
            </div>
            <span id={profileData?.available === 0 ? "text_of" : ""}>
              {lang.INACCESS}
            </span>
          </div>
          {/* special status */}
          <div
            onClick={() => {
              dispatch(setTechOrderTab(3));
            }}
            className={
              techOrderTab === 3 ? "tech-app-orders-status-active" : ""
            }
            id="order_status_tabs_special"
          >
            <div>
              <img
                id={profileData?.available === 0 ? "image_of" : ""}
                src={timeTask}
                alt="complete orders"
              />
            </div>
            <span id={profileData?.available === 0 ? "text_of" : ""}>
              {lang.PROMOTION_BOXـORDER}
            </span>
          </div>
          {/* doing status */}
          <div
            onClick={() => {
              dispatch(setTechOrderTab(2));
            }}
            className={
              techOrderTab === 2 ? "tech-app-orders-status-active" : ""
            }
            id="order_status_tabs_doing"
          >
            <div>
              <img
                id={profileData?.available === 0 ? "image_of" : ""}
                src={doingTask}
                alt="doing orders"
              />
            </div>
            <span id={profileData?.available === 0 ? "text_of" : ""}>
              {lang.DOING}
            </span>
          </div>
          {/* reject status */}
          <div
            onClick={() => {
              dispatch(setTechOrderTab(1));
            }}
            className={
              techOrderTab === 1 ? "tech-app-orders-status-active" : ""
            }
            id="order_status_tabs_reject"
          >
            <div>
              <img
                id={profileData?.available === 0 ? "image_of" : ""}
                src={failedTask}
                alt="failed orders"
              />
            </div>
            <span id={profileData?.available === 0 ? "text_of" : ""}>
              {lang.REJECT}
            </span>
          </div>
          {/* done status */}
          <div
            onClick={() => {
              dispatch(setTechOrderTab(0));
            }}
            className={
              techOrderTab === 0 ? "tech-app-orders-status-active" : ""
            }
            id="order_status_tabs_done"
          >
            <div>
              <img
                id={profileData?.available === 0 ? "image_of" : ""}
                src={completeTask}
                alt="complete task"
              />
            </div>
            <span id={profileData?.available === 0 ? "text_of" : ""}>
              {lang.DONE}
            </span>
          </div>
        </div>
        {/* locked profile alert */}
        {profileData?.verified === 0 &&
          profileData?.unverified_message?.length > 0 ? (
          <div className="user-suspend">
            <img
              src={lockIcon}
              style={{ width: "17px", height: "17px", marginLeft: "3px" }}
              alt="user-suspend"
            />
            <span style={{ fontSize: "11px" }}>
              {lang.PROFILE_LOCKED_MESSAGE}
            </span>
            <Button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "red",
                height: 30,
                width: 84,
                borderRadius: 999,
                fontSize: 10,
                color: "white",
              }}
              onClick={() => setLockModal(true)}
            >
              {lang.VIEW_DETAILS}
            </Button>
            {/* help popover */}
            {hints.map((hint, index) => {
              if (
                hint.section === "orders_locked_profile" &&
                hint.type === "text" &&
                hint.body.length > 0
              ) {
                return (
                  <Popover
                    key={index}
                    trigger={"click"}
                    placement="bottom"
                    title={<div style={{ textAlign: "right" }}>راهنما</div>}
                    content={
                      <div style={{ textAlign: "right", maxWidth: 270 }}>
                        {hint.body}
                      </div>
                    }
                  >
                    <div style={{ marginRight: 8 }} className="help_button">
                      <IoIosHelpCircleOutline
                        style={{ color: "#1e5279", fontSize: 22 }}
                      />
                    </div>
                  </Popover>
                );
              } else if (
                hint.section === "orders_locked_profile" &&
                hint.type === "link" &&
                hint.body.length > 0
              ) {
                return (
                  <div
                    style={{ marginRight: 8 }}
                    onClick={() => window.open(hint.body, "_blank")}
                    className="help_button"
                  >
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                );
              }

              return '';
            })}
          </div>
        ) : null}
        {/* debt lock message */}
        {profileData?.balance < profileData?.debt_ceil ? (
          <div className="user-suspend">
            <img
              src={lockIcon}
              style={{ width: "17px", height: "17px", marginLeft: "3px" }}
              alt="user-suspend"
            />
            <span style={{ fontSize: "11px" }}>
              {lang.PROFILE_LOCKED_FOR_DEBTH_MESSAGE}
            </span>
            <Button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "red",
                height: 30,
                width: 84,
                borderRadius: 999,
                fontSize: 10,
                color: "white",
              }}
              onClick={() => {
                navigate("/techapp/transactions");
              }}
            >
              {lang.CHARGE_ACCOUNT}
            </Button>
            {/* help popover */}
            {hints.map((hint, index) => {
              if (
                hint.section === "orders_debt_profile_locked" &&
                hint.type === "text" &&
                hint.body.length > 0
              ) {
                return (
                  <Popover
                    key={index}
                    trigger={"click"}
                    placement="bottom"
                    title={<div style={{ textAlign: "right" }}>راهنما</div>}
                    content={
                      <div style={{ textAlign: "right", maxWidth: 270 }}>
                        {hint.body}
                      </div>
                    }
                  >
                    <div style={{ marginRight: 8 }} className="help_button">
                      <IoIosHelpCircleOutline
                        style={{ color: "#1e5279", fontSize: 22 }}
                      />
                    </div>
                  </Popover>
                );
              } else if (
                hint.section === "orders_debt_profile_locked" &&
                hint.type === "link" &&
                hint.body.length > 0
              ) {
                return (
                  <div
                    style={{ marginRight: 8 }}
                    onClick={() => window.open(hint.body, "_blank")}
                    className="help_button"
                  >
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                );
              }

              return '';
            })}
          </div>
        ) : null}
        {/* unavailable profile alert */}
        {profileData?.available === 0 && (
          <div className="user-suspend">
            <img
              src={availableIcon}
              style={{ width: "17px", height: "17px", marginLeft: 3 }}
              alt="user-suspend"
            />
            <span style={{ fontSize: "11px" }}>
              {lang.PROFILE_UNAVAILABLE_MESSAGE}
            </span>
            <Button
              style={{
                width: 84,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: Colors.warning,
                height: 30,
                borderRadius: 999,
                fontSize: "10px",
                color: "white",
              }}
              onClick={() => {
                setUnavailableModal(true);
              }}
            >
              {lang.VIEW_DETAILS}
            </Button>
            {/* help popover */}
            {hints.map((hint, index) => {
              if (
                hint.section === "orders_deactive_profile_locked" &&
                hint.type === "text" &&
                hint.body.length > 0
              ) {
                return (
                  <Popover
                    key={index}
                    trigger={"click"}
                    placement="bottom"
                    title={<div style={{ textAlign: "right" }}>راهنما</div>}
                    content={
                      <div style={{ textAlign: "right", maxWidth: 270 }}>
                        {hint.body}
                      </div>
                    }
                  >
                    <div style={{ marginRight: 8 }} className="help_button">
                      <IoIosHelpCircleOutline
                        style={{ color: "#1e5279", fontSize: 22 }}
                      />
                    </div>
                  </Popover>
                );
              } else if (
                hint.section === "orders_deactive_profile_locked" &&
                hint.type === "link" &&
                hint.body.length > 0
              ) {
                return (
                  <div
                    style={{ marginRight: 8 }}
                    onClick={() => window.open(hint.body, "_blank")}
                    className="help_button"
                  >
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                );
              }

              return '';
            })}
          </div>
        )}
        {/* lock description modal */}
        <Modal
          footer={[]}
          open={lockModal}
          onCancel={() => setLockModal(false)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "15px",
            }}
          >
            <span
              style={{
                textAlign: "center",
                marginBottom: 15,
                color: "red",
                fontWeight: 900,
              }}
            >
              {lang.PROFILE_LOCKED}
            </span>
            <span
              style={{
                textAlign: "center",
                direction: "rtl",
              }}
            >
              {profileData?.unverified_message?.length > 0
                ? profileData?.unverified_message
                : lang.SEND_TICKET_TO_SUPPORT_FOR_MORE_INFO}
            </span>
            <Button
              onClick={() => setLockModal(false)}
              style={{
                backgroundColor: Colors.royalBlue,
                borderRadius: 999,
                height: 40,
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <span style={{ color: "white" }}>{lang.UNDERSTOOD}</span>
            </Button>
          </div>
        </Modal>
        {/* unavailable modal */}
        <Modal
          footer={[]}
          open={unavailableModal}
          onCancel={() => setUnavailableModal(false)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "15px",
            }}
          >
            <span
              style={{
                textAlign: "center",
                marginBottom: 15,
                color: Colors.warning,
                fontWeight: 900,
              }}
            >
              {lang.PROFILE_UNAVAILABLE}
            </span>
            <span
              style={{
                textAlign: "center",
                direction: "rtl",
              }}
            >
              {lang.PROFILE_UNAVAILABLE_DESCRIPTION}
            </span>
            <Button
              onClick={() => {
                setUnavailableModal(false);
                navigate("/techapp/profile");
              }}
              style={{
                backgroundColor: Colors.royalBlue,
                borderRadius: 999,
                height: 40,
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <span style={{ color: "white" }}>{lang.UNDERSTOOD}</span>
            </Button>
          </div>
        </Modal>
        <div className="tech-app-orders-body">
          {techOrderTab === 4 && <AvailableOrders />}
          {techOrderTab === 3 && <SpecialOrders />}
          {techOrderTab === 2 && <DoingOrders />}
          {techOrderTab === 1 && <FailedOrders />}
          {techOrderTab === 0 && <DoneOrders />}
          <div className="tech-app-orders-carousel">
            {sliderData?.length > 0 && (
              <Carousel autoplay>
                {sliderData?.map((sData, index) => (
                  <a
                    style={{ width: "100%", height: "100px" }}
                    href={sData.link}
                    target="_blank"
                    key={index}
                    rel="noreferrer"
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100px",
                        objectFit: "cover",
                      }}
                      src={sData.image}
                      alt="slider-image"
                    />
                  </a>
                ))}
              </Carousel>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Orders;
